import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Checkbox, Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'

import { FBSClientTranInfo } from '../Types'
import { SystemHeader, FBSClientPicker } from '../CommonUI';
import { Pagination, PageInfo } from '../CommonUI';

import i18next from 'i18next';


var GsbFlag: any;

var UserID: string;
var PgmCode = "FT0007" ;
var isReqAuth2:boolean = false ;

interface FBSClientTranEntryViewProps {
    gsb: AxiosInstance,
    ClientTran: FBSClientTranInfo,
    ClientTran0: FBSClientTranInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
}


export function FBSClientTranEntryView({ gsb, ClientTran = {} as FBSClientTranInfo, ClientTran0 = {} as FBSClientTranInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2}: FBSClientTranEntryViewProps) {


    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    const [AuthUser, setAuthUser] = useState("")
    const [password, setPassword] = useState("")

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
/*
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
*/

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    console.log("ClientTranEntryView UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, ClientTran])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_Seq" in ClientTran)) return null


    return (
        <div>
            {/* define add,change,delete button */}
            { ViewMode === "V" && <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }
                <Button className="Col-9-2" icon="document" onClick={() => { window.open(`/#/ClientPosEnquiry?acCode=${ClientTran.d_Acct}`, '_blank') } } >Balance & Portfolio</Button>
            </div> }
            { ViewMode === "L" && <div>
                Seq No. : {ClientTran.d_Seq}
                { (logKey2.indexOf("*A1") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Amend</div> }
                { (logKey2.indexOf("*C") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Create</div> }
                { (logKey2.indexOf("*D") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Delete</div> }
                { ! (ClientTran0.d_AuthId.toString() == "") && <div id="DispText2">Auth : {utils.dispDate(ClientTran0.d_AuthDate, "3")} {ClientTran0.d_AuthTime} User {ClientTran0.d_AuthId} </div> }
                <div className="Spacing-V-16" />
            </div> }

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Seq No.">
                    <InputGroup readOnly value={ClientTran.d_Seq} />
                </FormGroup>
                <FormGroup className="Col-5-1" label="Input User" labelFor="inputInputUser">
                    <InputGroup readOnly value={ClientTran.d_Userid} />
                </FormGroup>
                <FormGroup className="Col-6-1" label="Action" labelFor="inputAction">
                    <InputGroup readOnly value={ClientTran.d_Action} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account No." labelFor="inputacCode" labelInfo="*">
                    <InputGroup readOnly value={ClientTran.d_Acct} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_Acct.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_Acct} </div> }
                </FormGroup>
                <FormGroup className="Col-2-3" label="Account Name">
                    <div id="DispText">{ClientTran.d_acName1}</div>
                    <div id="DispText">{ClientTran.d_acName2}</div>
                </FormGroup>
                <FormGroup className="Col-5-2" label="Tran Date" labelFor="input_Tran_date">
                    <InputGroup readOnly value= {utils.dispDate(ClientTran.d_Date, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_Date.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(ClientTran0.d_Date, GsbFlag.dateFormat)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Position" labelFor="inputPosition" labelInfo="*">
                    <InputGroup readOnly value={utils.fbsPositionTypeName(ClientTran.d_Type)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_Type.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_Type} </div> }
                </FormGroup>
                <FormGroup className="Col-5-2" label="Trade Date" labelFor="input_Trade_date">
                    <InputGroup readOnly value= {utils.dispDate(ClientTran.d_ODate, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_ODate.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(ClientTran0.d_ODate, GsbFlag.dateFormat)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Commodity" labelFor="inputComdy" labelInfo="*">
                    <InputGroup readOnly value={ClientTran.d_Comdy} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_Comdy.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_Comdy} </div> }
                </FormGroup>
                <FormGroup className="Col-2-1" label="Expiry Month" labelFor="inputDMon" labelInfo="*">
                    <InputGroup readOnly value={ClientTran.d_DMon} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_DMon.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_DMon} </div> }
                </FormGroup>
                <FormGroup className="Col-3-3" label="Commodity Name" labelFor="inputComdyName">
                    <div>
                    <div id="DispText">{ClientTran.d_ComdyName}</div>
                    </div>
                </FormGroup>
                <FormGroup className="Col-6-1" label="Exchange">
                    <div>
                    <div id="DispText">{ClientTran.d_Market}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Call / Put">
                    <InputGroup readOnly value={utils.fbsCallPutTypeName(ClientTran.d_CallPut)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_CallPut.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_CallPut} </div> }
                </FormGroup>
                <FormGroup className="Col-2-1" label="Strike Price" labelFor="inputStrike_Price">
                    <InputGroup readOnly type='number' value={ClientTran.d_Strike} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_Strike.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_Strike} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Bought / Sold" labelInfo="*">
                    <InputGroup readOnly value={utils.fbsBuySellTypeName(ClientTran.d_BSType)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_BSType.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_BSType} </div> }
                </FormGroup>
                <FormGroup className="Col-2-1" label="Quantity" labelFor="inputTrade_Qty">
                    <InputGroup readOnly type='number' value={utils.numToString(ClientTran.d_Qty)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_Qty.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(ClientTran0.d_Qty)} </div> }
                </FormGroup>
                <FormGroup className="Col-3-1" label="Trading Price" labelFor="inputTrade_Price">
                    <InputGroup readOnly type='number' value={ClientTran.d_Price} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_Price.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_Price} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Comm. Class" labelFor="inputCommCode">
                    <InputGroup readOnly value={ClientTran.d_CommCode} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_CommCode.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_CommCode} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Counterparty" labelFor="inputCParty">
                    <InputGroup readOnly value={ClientTran.d_CParty} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_CParty.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_CParty} </div> }
                </FormGroup>
                <FormGroup className="Col-2-1" label="Ref#" labelFor="inputRefNo">
                    <InputGroup readOnly value={ClientTran.d_RefNo} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_RefNo.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_RefNo} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                {/* <FormGroup className="Col-1-1" label="User Fee" labelFor="inputUserFee">
                    <InputGroup readOnly value={ClientTran.d_UserFee == 'Y' ? 'Y' : 'N'} />
                    <Checkbox readOnly checked={ClientTran.d_UserFee == 'Y'}></Checkbox>
                </FormGroup> */}
                <RadioGroup className="Col-1-1" disabled inline selectedValue={ClientTran.d_UserFee == "Y" ? "Y" : "N"} label="User Fee" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_UserFee.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_UserFee} </div> }
                </RadioGroup>
                {ClientTran.d_UserFee == 'Y' && <FormGroup className="Col-2-1" label="Levy" labelFor="inputLevy">
                    <InputGroup readOnly value={utils.formatNumber2(ClientTran.d_Levy)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_Levy.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(ClientTran0.d_Levy)} </div> }
                </FormGroup>}
                {ClientTran.d_UserFee == 'Y' && <FormGroup className="Col-3-1" label="Exchange Fee" labelFor="inputExchange">
                    <InputGroup readOnly value={utils.formatNumber2(ClientTran.d_Exchange)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_Exchange.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(ClientTran0.d_Exchange)} </div> }
                </FormGroup>}
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Mirror#" labelFor="inputMirror">
                    <InputGroup readOnly value={ClientTran.d_Mirror} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_Mirror.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_Mirror} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                {/* <FormGroup className="Col-1-1" label="Init by Broker" labelFor="inputBrokerInit">
                    <Checkbox readOnly id="inputBrokerInit" name="d_BrokerInit" checked={ClientTran.d_BrokerInit}></Checkbox>
                </FormGroup> */}
                <RadioGroup className="Col-1-1" disabled inline selectedValue={ClientTran.d_BrokerInit ? "Y" : "N"} label="Init by Broker" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ClientTran0.d_BrokerInit.toString() == "") && 
                    <div id="DispText2" > {ClientTran0.d_BrokerInit ? "Y" : "N"} </div> }
                </RadioGroup>
            </div>
        </div>
    )
}

interface FBSClientTranEntryEditProps {
    gsb: AxiosInstance,
    ClientTran?: FBSClientTranInfo,
    isNew?: boolean,
    onSave?: (stk: FBSClientTranInfo) => void,
    onCancel?: () => void,
}

export function FBSClientTranEntryEdit({ gsb, ClientTran = {} as FBSClientTranInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: FBSClientTranEntryEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FBSClientTranInfo>()

    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [AcCodeValue, setAcCodeValue] = useState(ClientTran.d_Acct)
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)
    const [AcName1Value, setAcName1Value] = useState(ClientTran.d_acName1)
    const [AcName2Value, setAcName2Value] = useState(ClientTran.d_acName2)
    const [ComdyValue, setComdyValue] = useState(ClientTran.d_Comdy)
    const [ComdyNameValue, setComdyNameValue] = useState("")
    const [MarketValue, setMarketValue] = useState(ClientTran.d_Market)
    const [CommCodeValue, setCommCodeValue] = useState(ClientTran.d_CommCode)
    const [UserFeeValue, setUserFeeValue] = useState(ClientTran.d_UserFee == "Y" ? "Y" : "N")
    const [BrokerInitValue, setBrokerInitValue] = useState(ClientTran.d_BrokerInit ? "Y" : "N")

    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastEdit UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])

    useEffect(() => {
        // Call reset to get the values of record ClientTranInfo 
        if ("d_Seq" in ClientTran) {
            reset(ClientTran)
        }
    }, [ClientTran, reset])


    useEffect(() => {
        // Some components (e.g. Suggest) don't have ref to use with react-hook-form, so register the fields manually and call setValue when item is selected
        // register({ name: "d_FieldName" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    useEffect(() => {
        (async () => {
            try {
                // get AC Info
                const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "CLMast", cAction: "GetCLInfo", cAcct: AcCodeValue})
                
                if ( AcCodeValue.trim().length > 0 && res.data.count > 0 )
                {
                    setAcName1Value(res.data.data[0].d_Name)
                    setAcName2Value(res.data.data[0].d_Name2)
                    // setCommCodeValue(res.data.data[0].d_CommCode)
                } else { 
                    setAcName1Value("")
                    setAcName2Value("")
                    // setCommCodeValue("")
                }
            
            } catch (error) {
                //showErrorBox(error)
            }
        })()

    }, [gsb, AcCodeValue])

    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "ComdyMast", cAction: "GetComdyInfo", cComdy: ComdyValue})
                
                if ( ComdyValue.trim().length > 0 && res.data.count > 0 )
                {
                    setComdyNameValue(res.data.data[0].d_ComdyName)
                    setMarketValue(res.data.data[0].d_Market)

                } else { 
                    setComdyNameValue("")
                    setMarketValue("")
                }
               
            } catch (error) {
                //showErrorBox(error)
            }
        })()
    }, [gsb, ComdyValue])

    if (! isNew && ! ("d_Seq" in ClientTran)) return null

    let acNoLength = 12
    
    const onSubmit = (data: FBSClientTranInfo) => {
        // put value to json/field before write database dbf
        data.d_UserFee = UserFeeValue;
        data.d_BrokerInit = BrokerInitValue == "Y";

        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }

        (async () => {
            try {
                const res = await gsb.post('/fbs/Transaction', {sb_data: data, cPgmId: "ClientTranEntry", cAction: "ClientTranValidate", isNew: isNew})

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    return (
        <form onKeyDown={handleHotkey}>
            <FBSClientPicker gsb={gsb} isOpen={isClPickerOpen} onClose={()=>setIsClPickerOpen(false)} onSelect={(ac)=>{setAcCodeValue(ac.d_Acct); setIsClPickerOpen(false)}}/>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Seq No." labelFor="inputSeqNo">
                    <InputGroup className="inputNumberNoSpin" disabled={true} id="inputSeqNo" name="d_Seq" defaultValue="" placeholder='Auto-generated' inputRef={register} />
                    {errors.d_Seq && errors.d_Seq.type === "required" && (<span id="Err_msg">Seq No. cannot be Blank</span>)}
                    {errors.d_Seq && errors.d_Seq.types && <span id="Err_msg">{errors.d_Seq.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-5-1" label="Input User" labelFor="inputInputUser">
                    <InputGroup disabled={true} id="inputInputUser" name="d_Userid" defaultValue="" placeholder="Input User ..." inputRef={register({ maxLength: 10}) } />
                    {errors.d_Userid && errors.d_Userid.type === "maxLength" && <span id="Err_msg">Max length is 10</span>}
                    {errors.d_Userid && errors.d_Userid.types && <span id="Err_msg">{errors.d_Userid.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-6-1" label="Action" labelFor="inputAction">
                    <InputGroup disabled={true} id="inputAction" name="d_Action" defaultValue="" placeholder="Action ..." inputRef={register({ maxLength: 1}) } />
                    {errors.d_Action && errors.d_Action.type === "maxLength" && <span id="Err_msg">Max length is 1</span>}
                    {errors.d_Action && errors.d_Action.types && <span id="Err_msg">{errors.d_Action.types.message}</span>}
                </FormGroup>
             </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account No." labelFor="inputacCode" labelInfo="*">
                    <InputGroup id="inputacCode" name="d_Acct" value={AcCodeValue} autoFocus placeholder="Account No. ..." onChange={utils.handleStringChange(s => setAcCodeValue(s.toUpperCase()))} inputRef={register({ required: true , maxLength: acNoLength}) } 
                        rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setIsClPickerOpen(true)}}></Button>}
                    />
                    {errors.d_Acct && errors.d_Acct.type === "required" && <span id="Err_msg">Account No. cannot be Blank</span>}
                    {errors.d_Acct && errors.d_Acct.type === "maxLength" && <span id="Err_msg">Max length is {acNoLength}</span>}
                    {errors.d_Acct && errors.d_Acct.types && <span id="Err_msg">{errors.d_Acct.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-3" label="Account Name">
                    <div id="DispText">{AcName1Value}</div>
                    <div id="DispText">{AcName2Value}</div>
                </FormGroup>
                <FormGroup className="Col-5-2" label="Tran Date" labelFor="input_Tran_date">
                    <InputGroup disabled={true} id="input_Tran_date" name="d_Date" defaultValue="" type="date" placeholder="Tran Date ..." inputRef={register} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Position" labelFor="inputPosition" labelInfo="*">
                    <HTMLSelect id="inputPosition" fill
                        name="d_Type"
                        elementRef={register}
                    >
                        <option value="O">{utils.fbsPositionTypeName("O")}</option>
                        <option value="T">{utils.fbsPositionTypeName("T")}</option>
                        <option value="G">{utils.fbsPositionTypeName("G")}</option>
                    </HTMLSelect>
                </FormGroup>
                <FormGroup className="Col-5-2" label="Trade Date" labelFor="input_Trade_date">
                    <InputGroup disabled={true} id="input_Trade_date" name="d_ODate" defaultValue="" type="date" placeholder="Trade Date ..." inputRef={register} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Commodity" labelFor="inputComdy" labelInfo="*">
                    <InputGroup id="inputComdy" name="d_Comdy" value={ComdyValue} placeholder="Commodity ..." onChange={utils.handleStringChange(s => setComdyValue(s.toUpperCase()))} inputRef={register({ required: true , maxLength: 5}) } />
                    {errors.d_Comdy && errors.d_Comdy.type === "required" && <span id="Err_msg">Commodity cannot be Blank</span>}
                    {errors.d_Comdy && errors.d_Comdy.type === "maxLength" && <span id="Err_msg">Max length is 5</span>}
                    {errors.d_Comdy && errors.d_Comdy.types && <span id="Err_msg">{errors.d_Comdy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Expiry Month" labelFor="inputDMon" labelInfo="*">
                    <InputGroup id="inputDMon" name="d_DMon" defaultValue="" placeholder="Expiry Month ..." onChange={utils.handleStringChange(s => setValue("d_DMon", s.toUpperCase())) } inputRef={register({ required: true , maxLength: 7}) } />
                    {errors.d_Comdy && errors.d_Comdy.type === "required" && <span id="Err_msg">Expiry Month cannot be Blank</span>}
                    {errors.d_Comdy && errors.d_Comdy.type === "maxLength" && <span id="Err_msg">Max length is 7</span>}
                    {errors.d_Comdy && errors.d_Comdy.types && <span id="Err_msg">{errors.d_Comdy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-3" label="Commodity Name" labelFor="inputComdyName">
                    <div>
                    <div id="DispText">{ComdyNameValue}</div>
                    </div>
                </FormGroup>
                <FormGroup className="Col-6-2" label="Exchange">
                    <div>
                    <div id="DispText">{MarketValue}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Call / Put" labelFor="inputCallPut">
                    <HTMLSelect id="inputCallPut" fill
                        name="d_CallPut"
                        elementRef={register}
                    >
                        <option value=""></option>
                        <option value="C">{utils.fbsCallPutTypeName("C")}</option>
                        <option value="P">{utils.fbsCallPutTypeName("P")}</option>
                    </HTMLSelect>
                </FormGroup>
                <FormGroup className="Col-2-1" label="Strike Price" labelFor="inputStrike">
                    <InputGroup id="inputStrike" name="d_Strike" defaultValue={""} type="number" inputRef={register} />
                    {errors.d_Strike && errors.d_Strike.types && <span id="Err_msg">{errors.d_Strike.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Bought / Sold" labelFor="inputBSType" labelInfo="*">
                    <HTMLSelect id="inputBSType" fill
                        name="d_BSType"
                        elementRef={register}
                    >
                        <option value="B">{utils.fbsBuySellTypeName("B")}</option>
                        <option value="S">{utils.fbsBuySellTypeName("S")}</option>
                    </HTMLSelect>
                </FormGroup>
                <FormGroup className="Col-2-1" label="Quantity" labelFor="inputTrade_Qty">
                    <InputGroup id="inputTrade_Qty" name="d_Qty" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_Qty && errors.d_Qty.types && <span id="Err_msg">{errors.d_Qty.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Trading Price" labelFor="inputTrade_Price">
                    <InputGroup id="inputTrade_Price" name="d_Price" defaultValue={"0"} type="number" inputRef={register} />
                    {errors.d_Price && errors.d_Price.types && <span id="Err_msg">{errors.d_Price.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Comm. Class" labelFor="inputCommCode">
                    <InputGroup id="inputCommCode" name="d_CommCode" defaultValue={CommCodeValue} value={CommCodeValue} onChange={utils.handleStringChange(s => setCommCodeValue(s))} inputRef={register({ maxLength: 2 }) } />
                    {errors.d_CommCode && errors.d_CommCode.type === "required" && (<span id="Err_msg">Commission Code cannot be Blank</span>)}
                    {errors.d_CommCode && errors.d_CommCode.type === "maxLength" && <span id="Err_msg">Max length is 2</span>}
                    {errors.d_CommCode && errors.d_CommCode.types && <span id="Err_msg">{errors.d_CommCode.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Counterparty" labelFor="inputCParty">
                    <InputGroup id="inputCParty" name="d_CParty" defaultValue={""} inputRef={register} />
                    {errors.d_CParty && errors.d_CParty.types && <span id="Err_msg">{errors.d_CParty.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Ref#" labelFor="inputRefNo">
                    <InputGroup id="inputRefNo" name="d_RefNo" defaultValue={""} inputRef={register} />
                    {errors.d_RefNo && errors.d_RefNo.types && <span id="Err_msg">{errors.d_RefNo.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-1" inline selectedValue={UserFeeValue} label="User Fee" onChange={utils.handleStringChange(s => setUserFeeValue(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
                {UserFeeValue == "Y" && <>
                <FormGroup className="Col-2-1" label="Levy" labelFor="inputLevy">
                    <InputGroup id="inputLevy" name="d_Levy" defaultValue={""} type="number" inputRef={register} />
                    {errors.d_Levy && errors.d_Levy.types && <span id="Err_msg">{errors.d_Levy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Exchange" labelFor="inputExchange">
                    <InputGroup id="inputExchange" name="d_Exchange" defaultValue={""} type="number" inputRef={register} />
                    {errors.d_Exchange && errors.d_Exchange.types && <span id="Err_msg">{errors.d_Exchange.types.message}</span>}
                </FormGroup>
                </>}
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Mirror#" labelFor="inputMirror">
                    <InputGroup id="inputMirror" name="d_Mirror" defaultValue={""} inputRef={register} />
                    {errors.d_Mirror && errors.d_Mirror.types && <span id="Err_msg">{errors.d_Mirror.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-1" inline selectedValue={BrokerInitValue} label="Init by Broker" onChange={utils.handleStringChange(s => setBrokerInitValue(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
            </div>
        </form>
    )
}

interface FBSClientTranEntryMainProps {
    gsb: AxiosInstance
}

// const toaster = Toaster.create({
//     position: Position.TOP,
// })

function FBSClientTranEntryMain({ gsb }: FBSClientTranEntryMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { StkNo: defaultSearchValue = "" }: { StkNo: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as FBSClientTranInfo[])

    const [searchKey, setSearchKey] = useState("SeqNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)
    const [searchAcName, setSearchAcName] = useState("")
    const [searchComdy, setSearchComdy] = useState("")
    
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentClientTran, setcurrentClientTran] = useState({} as FBSClientTranInfo)
    const [CurrentLog1, setCurrentLog1] = useState({} as FBSClientTranInfo)
    const [CurrentLog0, setCurrentLog0] = useState({} as FBSClientTranInfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                UserID = res.data.Flag.UserID
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])

    useEffect(() => {

        if (logviewonly === "Y") {
            setViewMode("L")
        }
        //console.log("ClMastMain ViewMode: ", ViewMode)

        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 ) {
                    const res = await gsb.post('/fbs/Transaction', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "ClientTranEntry", 
                        cAction: "ViewLogRec"
                    })
                    //console.log("FBSClMastMain ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog0(res.data.data[0])
                        setCurrentLog1(res.data.data[1])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])



    const PrevRecProcess = async (ClientTran: FBSClientTranInfo) => {
        try {
            const res = await gsb.post('/fbs/Transaction', {sb_data: ClientTran, cPgmId: "ClientTranEntry", cAction: "PrevRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Seq === res.data.data.d_Seq) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentClientTran(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (ClientTran: FBSClientTranInfo) => {
        try {
            ClientTran.d_AuthTran = ""
            if (isReqAuth2) {
                ClientTran.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/fbs/Transaction', {sb_data: ClientTran, cPgmId: "ClientTranEntry", cAction: "DelRec"})
            if (isReqAuth2) {
                utils.showSuccess("Seq No. " + ClientTran.d_Seq + " record deleting, waiting for authorization")
            } else {
                utils.showSuccess("Seq No. " + ClientTran.d_Seq + " record deleted")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Seq === res.data.data.d_Seq) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setcurrentClientTran(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                utils.showSuccess("Seq No. " + ClientTran.d_Seq + " record deleting, waiting for authorization")
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (ClientTran: FBSClientTranInfo) => {
        try {
            //console.log("call NextRecProcess", ClientTran)
            const res = await gsb.post('/fbs/Transaction', {sb_data: ClientTran, cPgmId: "ClientTranEntry", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Seq === res.data.data.d_Seq) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentClientTran(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (ClientTran: FBSClientTranInfo) => {
        try {
            //console.log("call newOnSave", ClientTran)
            const res = await gsb.post('/fbs/Transaction', {sb_data: ClientTran, cPgmId: "ClientTranEntry", cAction: "AddRec"})
            //showSuccess("Seq No. " + ClientTran.d_Seq + " record added")
            if (isReqAuth2) {
                utils.showSuccess("Seq No. " + res.data.data.d_Seq + " record adding, waiting for authorization")
            } else {
                utils.showSuccess("Seq No. " + res.data.data.d_Seq + " record added")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Seq === res.data.data.d_Seq) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setcurrentClientTran(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                setShowAlert1Msg("Seq No. " + res.data.data.d_Seq + " record adding, waiting for authorization")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (ClientTran: FBSClientTranInfo) => {
        try {
            //console.log("call editOnSave", ClientTran)
            const res = await gsb.post('/fbs/Transaction', {sb_data: ClientTran, cPgmId: "ClientTranEntry", cAction: "UpdateRec"})
            if (isReqAuth2) {
                utils.showSuccess("Seq No. " + ClientTran.d_Seq + " record saving, waiting for authorization")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Seq === res.data.data.d_Seq) {
                        setcurrentClientTran(data[i])
                        break
                    }
                }
                setCurrentMode("show")
                setisShowAlert1(true)
                setShowAlert1Msg("Seq No. " + ClientTran.d_Seq + " record saving, waiting for authorization")
            } else {
                utils.showSuccess("Seq No. " + ClientTran.d_Seq + " record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Seq === res.data.data.d_Seq) {
                        data[i] = { ...data[i], ...res.data.data }
                        //console.log("editOnSave data", i, data)
                        setData(data)
                        break
                    }
                }
                //console.log("editOnSave res.data.data", res.data.data)
                setcurrentClientTran(res.data.data)
                setCurrentMode("show")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        try {
            //console.log("ClientTranEntryMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/fbs/Transaction',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            acName: searchAcName,
                            comdy: searchComdy,
                        }, 
                    },
                    cPgmId: "ClientTranEntry",
                    cAction: "ListRec",
                });

                //console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentClientTran(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/fbs/Transaction',
                {   sb_data: {
                        d_Seq: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "ClientTranEntry",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setcurrentClientTran(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("ClientTranEntryMain useEffect length > 0  called", data)
                const res = await gsb.post('/fbs/Transaction',
                    {   sb_data: {
                            by: "SeqNo",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "ClientTranEntry",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentClientTran(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    const res = await gsb.post('/fbs/Transaction',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                acName: searchAcName,
                                comdy: searchComdy,
                            }, 
                        },
                        cPgmId: "ClientTranEntry",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setcurrentClientTran(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    // currentMode = show
    let detail = <FBSClientTranEntryView gsb={gsb} ClientTran={currentClientTran} ClientTran0={currentClientTran} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentClientTran)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentClientTran)} onNextRec={() => NextRecProcess(currentClientTran)} ViewMode={ViewMode} logKey2={logKey2.trim()}></FBSClientTranEntryView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <FBSClientTranEntryEdit gsb={gsb} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></FBSClientTranEntryEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <FBSClientTranEntryEdit gsb={gsb} ClientTran={currentClientTran} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></FBSClientTranEntryEdit>
            break
        }

    let logKeyViewRec = <FBSClientTranEntryView gsb={gsb} ClientTran={CurrentLog1} ClientTran0={CurrentLog0} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentClientTran)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentClientTran)} onNextRec={() => NextRecProcess(currentClientTran)} ViewMode={ViewMode} logKey2={logKey2.trim()}></FBSClientTranEntryView>

    let pagination = <Pagination nPage={nPage} nTotalPage={nTotalPage} aPageNumber={aPageNumber} setnPage={(n)=>setnPage(n)}></Pagination>
    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-120">Seq No</th>
                <th className="TCol-120">Account No.</th>
                <th className="TCol-300">Name</th>
                <th className="TCol-100">Commodity</th>
                <th className="TCol-100">D.Month</th>
                <th className="TCol-100">Call / Put</th>
                <th className="TCol-100">Strike</th>
                <th className="TCol-100">Long</th>
                <th className="TCol-100">Short</th>
                <th className="TCol-100">Price</th>
                <th className="TCol-60">Action</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((ClientTran, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td onClick={() => { setcurrentClientTran(ClientTran) ; MoblieDev && setSelectedTabId("detail") }}>{ClientTran.d_Seq}</td>
                        <td onClick={() => { setcurrentClientTran(ClientTran) ; MoblieDev && setSelectedTabId("detail") }}>{ClientTran.d_Acct}</td>
                        <td onClick={() => { setcurrentClientTran(ClientTran) ; MoblieDev && setSelectedTabId("detail") }}>{ClientTran.d_acName1}</td>
                        <td onClick={() => { setcurrentClientTran(ClientTran) ; MoblieDev && setSelectedTabId("detail") }}>{ClientTran.d_Comdy}</td>
                        <td onClick={() => { setcurrentClientTran(ClientTran) ; MoblieDev && setSelectedTabId("detail") }}>{ClientTran.d_DMon}</td>
                        <td onClick={() => { setcurrentClientTran(ClientTran) ; MoblieDev && setSelectedTabId("detail") }}>{ClientTran.d_CallPut}</td>
                        <td onClick={() => { setcurrentClientTran(ClientTran) ; MoblieDev && setSelectedTabId("detail") }}>{ClientTran.d_Strike}</td>
                        <td onClick={() => { setcurrentClientTran(ClientTran) }}>{ClientTran.d_BSType === "B" && ClientTran.d_Qty}</td>
                        <td onClick={() => { setcurrentClientTran(ClientTran) }}>{ClientTran.d_BSType === "S" && ClientTran.d_Qty}</td>
                        <td onClick={() => { setcurrentClientTran(ClientTran) }}>{ClientTran.d_Price}</td>
                        <td onClick={() => { setcurrentClientTran(ClientTran) }}>{ClientTran.d_Action}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Trade Entry</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for Client Transaction " labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="SeqNo">Seq No</option>
                                    {/* <option value="acCode">Account No.</option> */}
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "SeqNo"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "SeqNo"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                        <Button className="Col-9-1 Button-LabeledFormGroup" icon="document" onClick={() => { window.open(`/#/fbs/ClientTranCheckList`, '_blank') } } >Check List</Button>
                        </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            <FormGroup className="Col-1-2" label="Account Name" labelFor="searchAcName">
                                <InputGroup id="searchAcName" value={searchAcName} onChange={utils.handleStringChange(s => setSearchAcName(s.toUpperCase()))} />
                            </FormGroup>
                            <FormGroup className="Col-3-1" label="Commodity" labelFor="searchComdy">
                                <InputGroup id="searchComdy" value={searchComdy} onChange={utils.handleStringChange(s => setSearchComdy(s.toUpperCase()))} />
                            </FormGroup>
                            {/* <FormGroup className="Col-6-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Trade Entry Log View</H3>
                    <div className="Spacing-V-16" />
                    {logKeyViewRec}
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default FBSClientTranEntryMain